import { animateScroll  } from 'react-scroll';
const scrollToTopUtil = () => animateScroll.scrollToTop();
export default scrollToTopUtil;
